import { MantineColor } from '@mantine/core'
import { maxBy } from 'lodash-es'
import { VlmModel } from '@/types/vlm'

export type VlmModelConfig = VlmModel & { color: MantineColor }

const MODEL_COLORS: Record<string, MantineColor> = {
  'vp-small/speed': 'teal.7',
  'vp-small/detail': 'teal.7',
  'vp-medium/speed': 'indigo.7',
  'vp-medium/detail': 'indigo.7',
  'vp-large/speed': 'grape.7',
  'vp-large/detail': 'grape.7'
}

const DEFAULT_MODEL_COLOR: MantineColor = 'gray.7'

export const toModelConfig = (model: VlmModel): VlmModelConfig => ({
  ...model,
  color: MODEL_COLORS[model.vlm_profile_id] ?? DEFAULT_MODEL_COLOR
})

// the most capable model the given number of GPUs can run
export const getFallbackModel = (models: VlmModel[], gpuCount: number) =>
  maxBy(
    models.filter((model) => model.min_required_gpus <= gpuCount),
    'min_required_gpus'
  )
